import React from 'react';

const NotFound: React.FunctionComponent = () => {

  return (
    <div className="home">
      The page was not found
    </div>
  );
}

export default NotFound;
